"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var quill_delta_1 = __importDefault(require("quill-delta"));
var PT_ATTRS = 'ptattrs';
(function (angularModule) {
    angularModule.factory('pr.quillMatcher', [
        function () {
            /**
             * A custom matcher for the quill clipboard module to convert HTML to deltas
             * correctly with piped text embedded. Code is copied from pr.product-base-component.
             * doc: https://quilljs.com/docs/modules/clipboard/#matchers
             */
            // @ts-ignore
            var quillMatcherForPipedText = function (node, delta) {
                if (lodash_1.default.includes(node.getAttributeNames(), PT_ATTRS)) {
                    var ptAttrsString = node.getAttribute(PT_ATTRS);
                    try {
                        return new quill_delta_1.default().insert({
                            'piped-text': {
                                // @ts-ignore
                                ptAttrs: JSON.parse(ptAttrsString)
                            }
                        });
                    }
                    catch (error) {
                        console.error('Failed to parse piped text attributes from dynamic translations HTML', error);
                        return delta;
                    }
                }
            };
            return {
                quillMatcherForPipedText: quillMatcherForPipedText
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
